module.exports = "https://static.wagwalking.com/_next/static/images/wagcompare-de700991d1a14b1cc151f11411feb943.jpg";